import ActiveEllipse from '../../../assets/icons/firm-management/active-ellipse.svg'
import InactiveEllipse from '../../../assets/icons/firm-management/inactive-ellipse.svg'

interface StateCellProps {
  isActive: boolean
}

export const StateCell: React.FC<StateCellProps> = ({ isActive }) => {
  if (isActive) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <ActiveEllipse />
        <span>Active</span>
      </span>
    )
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <InactiveEllipse />
      <span>Inactive</span>
    </span>
  )
}
